var PRIMARY_MOUSE_BUTTON = 0;
export default function isPrimaryMouseButton(event) {
  return event.type === 'mousedown' && event.button === PRIMARY_MOUSE_BUTTON;
}